// PM POSHAN day-wise meal plan (Odisha pattern), rates verified against MDM Reports app.
// Per-student TARGET COST is FIXED at Rs 11.15 (Primary group: BV+Primary) and Rs 14.74
// (Upper-Primary group: UP+HS) on EVERY working day, regardless of meal type.
// On Ladoo days (Tue/Thu/Sat) the ladoo ingredients (8 items totalling Rs 3.50) are
// INCLUDED inside the target — so Vegetables (residual) absorb the difference.

export const DAY_OF_WEEK_MEAL = {
  0: { dayCode: 0, mealType: "manual", mealName: "Holiday / Manual", ladoo: false },
  1: { dayCode: 1, mealType: "egg", mealName: "Egg Day", ladoo: false },
  2: { dayCode: 2, mealType: "soya", mealName: "Soya + Ladoo", ladoo: true },
  3: { dayCode: 3, mealType: "egg", mealName: "Egg Day", ladoo: false },
  4: { dayCode: 4, mealType: "dal", mealName: "Dal + Ladoo", ladoo: true },
  5: { dayCode: 5, mealType: "egg", mealName: "Egg Day", ladoo: false },
  6: { dayCode: 6, mealType: "soya", mealName: "Soya + Ladoo", ladoo: true },
};

export const TARGET_COST = {
  primary: 11.15,      // Bal Vatika + Primary
  upperPrimary: 14.74, // Upper Primary + High School
};

// Ladoo total per student on ladoo days (informational — already inside target).
export const LADOO_COST_PER_STUDENT = 3.5;

// ---------------------------------------------------------------------------
// Per-student item lines.
// costMode:
//   "calc"     → cost_per_student = qty * rate / 1000  (qty in gm/ml, rate per kg/L)
//   "perPiece" → cost_per_student = qty * rate          (e.g. egg)
//   "flat"     → cost_per_student = flatPerStudent      (regardless of qty)
//   "residual" → cost_per_student = target - sum(other lines)  (Vegetables only)
// ---------------------------------------------------------------------------

// MEAL items (non-ladoo). Same shape for Egg / Soya / Dal days; the protein line differs.
const COMMON_MEAL_PRIMARY_BASE = [
  { item: "Rice",            qty: 100, unit: "gm",   rate: 0,   rateLabel: "Free (FCI)", costMode: "calc",   isFree: true },
  { item: "Oil",             qty: 5,   unit: "ml",   rate: 140, rateLabel: "Rs 140/L",   costMode: "calc" },
  // Flat-cost items now also carry a real per-student qty so the daily entry,
  // MDCF Section 10 and Hand Receipts can display a non-zero quantity.
  { item: "Masala & Salt",   qty: 0,   unit: "gm",   rate: 0,   rateLabel: "Flat",        costMode: "flat",   flatPerStudent: 0.30, qtyPerStudent: 5 },
  { item: "Fuel",            qty: 0,   unit: "gm",   rate: 0,   rateLabel: "Flat",        costMode: "flat",   flatPerStudent: 0.76, qtyPerStudent: 8 },
];
const COMMON_MEAL_UPPER_BASE = [
  { item: "Rice",            qty: 150, unit: "gm",   rate: 0,   rateLabel: "Free (FCI)", costMode: "calc",   isFree: true },
  { item: "Oil",             qty: 7.5, unit: "ml",   rate: 140, rateLabel: "Rs 140/L",   costMode: "calc" },
  { item: "Masala & Salt",   qty: 0,   unit: "gm",   rate: 0,   rateLabel: "Flat",        costMode: "flat",   flatPerStudent: 0.45, qtyPerStudent: 7.5 },
  { item: "Fuel",            qty: 0,   unit: "gm",   rate: 0,   rateLabel: "Flat",        costMode: "flat",   flatPerStudent: 1.30, qtyPerStudent: 12 },
];

const PROTEIN_PRIMARY = {
  egg:  { item: "Egg",  qty: 1,  unit: "pc", rate: 7,      rateLabel: "Rs 7/pc",    costMode: "perPiece" },
  soya: { item: "Soya", qty: 12, unit: "gm", rate: 125,    rateLabel: "Rs 125/kg",  costMode: "calc" },
  dal:  { item: "Dal",  qty: 25, unit: "gm", rate: 114.80, rateLabel: "Rs 114.80/kg", costMode: "calc" },
};
const PROTEIN_UPPER = {
  egg:  { item: "Egg",  qty: 1,  unit: "pc", rate: 7,      rateLabel: "Rs 7/pc",    costMode: "perPiece" },
  soya: { item: "Soya", qty: 25, unit: "gm", rate: 125,    rateLabel: "Rs 125/kg",  costMode: "calc" },
  dal:  { item: "Dal",  qty: 30, unit: "gm", rate: 114.80, rateLabel: "Rs 114.80/kg", costMode: "calc" },
};

// Ladoo items — only added on ladoo days. Sum of cost-per-student = Rs 3.50.
export const LADOO_LINES = [
  { item: "Ragi Flour",        qty: 12,   unit: "gm", rate: 150,    rateLabel: "Rs 150/kg",  costMode: "calc" },
  { item: "Wheat Flour",       qty: 12,   unit: "gm", rate: 41.67,  rateLabel: "Rs 41.67/kg", costMode: "calc" },
  { item: "Sugar",             qty: 6,    unit: "gm", rate: 45,     rateLabel: "Rs 45/kg",   costMode: "calc" },
  { item: "Sesame",            qty: 1,    unit: "gm", rate: 140,    rateLabel: "Rs 140/kg",  costMode: "calc" },
  { item: "Ground Nuts",       qty: 1,    unit: "gm", rate: 150,    rateLabel: "Rs 150/kg",  costMode: "calc" },
  { item: "Refined Oil",       qty: 2,    unit: "ml", rate: 160,    rateLabel: "Rs 160/L",   costMode: "calc" },
  { item: "Cardamom",          qty: 0.5,  unit: "gm", rate: 120,    rateLabel: "Rs 120/kg",  costMode: "calc" },
  { item: "Ladoo Making Cost", qty: 1,    unit: "pc", rate: 0.26,   rateLabel: "Rs 0.26/ladoo", costMode: "perPiece" },
];

const VEG_PRIMARY = { item: "Vegetable", qty: 60,  unit: "gm", rate: 0, rateLabel: "Residual", costMode: "residual" };
const VEG_UPPER   = { item: "Vegetable", qty: 100, unit: "gm", rate: 0, rateLabel: "Residual", costMode: "residual" };

// iter144 — DB-backed rate card override. When admin edits ingredient
// qty / rate under Rate Cards, we mutate this object at runtime so every
// calc (Daily Entry, MDCF, Quarterly UC, Hand Receipts, Reports) picks up
// the new values without a page reload.
//   shape: {
//     primary:      { target: 11.15, byItem: { "Oil": {qty, rate, unit}, ... } },
//     upperPrimary: { target: 14.74, byItem: { ... } },
//   }
let _dbOverrides = null;

function _classToGroup(className) {
  if (className === "primary" || className === "balVatika") return "primary";
  if (className === "upperPrimary" || className === "highSchool") return "upperPrimary";
  return null;
}

function _unitToLegacy(u) {
  // Rate Card stores unit as g/kg/ml/L/pc. Daily-Entry lines use gm/ml/pc.
  const uu = (u || "g").toLowerCase();
  if (uu === "kg" || uu === "g") return "gm";
  if (uu === "l") return "ml";
  return uu;
}

/**
 * Load admin-managed rate cards and apply them as calculation overrides.
 * iter146 — stores overrides PER CLASS (balVatika, primary, upperPrimary,
 * highSchool). Daily-Entry aggregations then contribute per-class values
 * so admin edits to any one class only affect that class's students —
 * never the sibling class in the same group.
 *
 * @param {Array} cards — rate card documents from /api/rate-cards
 *                       (already filtered to currently-active if desired)
 */
export function setRateCardOverrides(cards) {
  if (!Array.isArray(cards) || cards.length === 0) {
    _dbOverrides = null;
    return;
  }
  const build = (card) => {
    if (!card) return null;
    const byItem = {};
    (card.ingredients || []).forEach((ing) => {
      byItem[String(ing.name || "").trim()] = {
        qty: Number(ing.qtyG) || 0,
        rate: Number(ing.ratePerKg) || 0,
        unit: _unitToLegacy(ing.unit),
      };
    });
    return { target: Number(card.cookingCostPerStu) || 0, byItem };
  };
  // Per-class map — one entry per rate-card className, so nothing is
  // ambiguous when a group holds two cards with different values.
  const byClass = {};
  for (const c of cards) {
    if (!c?.className) continue;
    byClass[c.className] = build(c);
  }
  // Sibling fallback: if only one class in a group is configured, share it
  // to the sibling class so the sibling isn't stuck on hardcoded defaults.
  const fall = (a, b) => { if (!byClass[a] && byClass[b]) byClass[a] = byClass[b]; };
  fall("balVatika", "primary"); fall("primary", "balVatika");
  fall("upperPrimary", "highSchool"); fall("highSchool", "upperPrimary");
  _dbOverrides = byClass;
}

export function getActiveRateCardOverrides() { return _dbOverrides; }

// Apply overrides to a freshly-built line array, mutating qty / rate / unit
// for items that appear in the current card. Items not in the card keep
// their hardcoded defaults so nothing silently breaks if admin only edited
// a subset. iter146 — now keyed by CLASS name (balVatika/primary/upperPrimary/
// highSchool), not by group.
function _applyOverrides(lines, className) {
  const ov = _dbOverrides?.[className];
  if (!ov?.byItem) return lines;
  return lines.map((l) => {
    const o = ov.byItem[l.item];
    if (!o) return l;
    const next = { ...l };
    if (l.costMode === "flat") {
      // For flat items (Masala, Fuel) admin only tweaks per-student cost + qty.
      // rate stays 0. If admin set a positive rate → switch to normal calc.
      if (o.rate > 0 && o.qty > 0) {
        next.costMode = "calc";
        next.qty = o.qty;
        next.rate = o.rate;
        next.unit = o.unit || l.unit;
        next.rateLabel = `Rs ${o.rate}/${o.unit === "gm" ? "kg" : o.unit === "ml" ? "L" : o.unit}`;
        delete next.flatPerStudent;
      } else {
        // Keep flat but update qty display + flat cost
        next.qtyPerStudent = o.qty > 0 ? o.qty : l.qtyPerStudent;
        // flatPerStudent stays as configured; admin can't set flat via card
      }
      return next;
    }
    if (l.costMode === "perPiece") {
      next.qty = o.qty || l.qty;
      next.rate = o.rate || l.rate;
      next.rateLabel = `Rs ${next.rate}/pc`;
      return next;
    }
    if (l.costMode === "residual") return next; // vegetables absorb the difference
    // calc mode (rice, oil, dal, soya, ladoo lines...)
    if (o.qty > 0) next.qty = o.qty;
    if (o.rate > 0) next.rate = o.rate;
    if (o.unit) next.unit = o.unit;
    if (!l.isFree) next.rateLabel = `Rs ${next.rate}/${next.unit === "gm" ? "kg" : next.unit === "ml" ? "L" : next.unit}`;
    return next;
  });
}

function buildLines(group, mealType, ladoo, className) {
  const base = group === "primary" ? COMMON_MEAL_PRIMARY_BASE : COMMON_MEAL_UPPER_BASE;
  const protein = (group === "primary" ? PROTEIN_PRIMARY : PROTEIN_UPPER)[mealType];
  const veg = group === "primary" ? VEG_PRIMARY : VEG_UPPER;
  const lines = [...base];
  if (protein) lines.push({ ...protein });
  if (ladoo) LADOO_LINES.forEach((l) => lines.push({ ...l, isLadoo: true }));
  lines.push({ ...veg });
  // iter146 — apply per-CLASS overrides. When no className is supplied
  // (legacy callers), fall back to the "senior" class in the group so
  // pre-refactor behavior is preserved.
  const cls = className || (group === "primary" ? "primary" : "highSchool");
  return _applyOverrides(lines, cls);
}

function lineCostPerStudent(line, target, otherSum) {
  if (line.costMode === "flat") return Number((line.flatPerStudent || 0).toFixed(2));
  if (line.costMode === "perPiece") return Number((line.qty * line.rate).toFixed(2));
  if (line.costMode === "residual") {
    const v = target - otherSum;
    return v > 0 ? Number(v.toFixed(2)) : 0;
  }
  if (line.isFree) return 0;
  return Number(((line.qty * line.rate) / 1000).toFixed(2));
}

function computeGroupLines(mealType, ladoo, group, target, className) {
  const lines = buildLines(group, mealType, ladoo, className);
  let nonResidualSum = 0;
  const partial = lines.map((l) => {
    if (l.costMode === "residual") return { ...l, costPerStudent: 0 };
    const c = lineCostPerStudent(l, target, 0);
    nonResidualSum += c;
    return { ...l, costPerStudent: c };
  });
  return partial.map((l) =>
    l.costMode === "residual"
      ? { ...l, costPerStudent: lineCostPerStudent(l, target, nonResidualSum) }
      : l,
  );
}

export function getMealForDate(dateStr) {
  if (!dateStr) return null;
  const d = new Date(`${dateStr}T00:00:00`);
  if (Number.isNaN(d.getTime())) return null;
  return DAY_OF_WEEK_MEAL[d.getDay()];
}

/**
 * Build the day's full ingredient breakdown for a date + attendance.
 * attendance = { balVatika, primary, upperPrimary, highSchool }
 */
export function buildDayBreakdown(dateStr, attendance) {
  const meal = getMealForDate(dateStr);
  if (!meal) return null;

  const att = {
    balVatika: Number(attendance?.balVatika || 0),
    primary: Number(attendance?.primary || 0),
    upperPrimary: Number(attendance?.upperPrimary || 0),
    highSchool: Number(attendance?.highSchool || 0),
  };
  const primaryCount = att.balVatika + att.primary;
  const upperCount = att.upperPrimary + att.highSchool;
  const totalCount = primaryCount + upperCount;

  // iter146 — per-CLASS target + per-CLASS lines. Each class uses its own
  // rate card (falling back to group defaults when no card is configured).
  // This is what makes an admin edit to "High School rice = 200g" actually
  // reflect for High School students without touching Upper Primary.
  const classTarget = (cls, fallback) => {
    const t = _dbOverrides?.[cls]?.target;
    return t > 0 ? t : fallback;
  };
  const targetPri = _dbOverrides?.primary?.target > 0
    ? _dbOverrides.primary.target
    : (_dbOverrides?.balVatika?.target > 0 ? _dbOverrides.balVatika.target : TARGET_COST.primary);
  const targetUpr = _dbOverrides?.upperPrimary?.target > 0
    ? _dbOverrides.upperPrimary.target
    : (_dbOverrides?.highSchool?.target > 0 ? _dbOverrides.highSchool.target : TARGET_COST.upperPrimary);
  const targetBv = classTarget("balVatika", targetPri);
  const targetP  = classTarget("primary", targetPri);
  const targetUp = classTarget("upperPrimary", targetUpr);
  const targetHs = classTarget("highSchool", targetUpr);
  const ladooCostPerStudent = meal.ladoo ? LADOO_COST_PER_STUDENT : 0;

  if (meal.mealType === "manual") {
    return {
      ...meal,
      primaryGroupCount: primaryCount,
      upperGroupCount: upperCount,
      perClass: [
        { key: "balVatika", label: "Bal Vatika", count: att.balVatika, target: 0, perStudent: 0, mealCost: 0, ladooCost: 0, dayCost: 0, lines: [] },
        { key: "primary", label: "Primary", count: att.primary, target: 0, perStudent: 0, mealCost: 0, ladooCost: 0, dayCost: 0, lines: [] },
        { key: "upperPrimary", label: "Upper Primary", count: att.upperPrimary, target: 0, perStudent: 0, mealCost: 0, ladooCost: 0, dayCost: 0, lines: [] },
        { key: "highSchool", label: "High School", count: att.highSchool, target: 0, perStudent: 0, mealCost: 0, ladooCost: 0, dayCost: 0, lines: [] },
      ],
      totals: { mealCost: 0, ladooCost: 0, dayCost: 0 },
      aggregate: [],
    };
  }

  // iter146 — Compute per-CLASS lines. Each class uses its own rate card
  // (or falls back to sibling's card / defaults). Aggregation now sums
  // Σ(class_lines × class_attendance) — so admin edits to a single class
  // affect that class's students only.
  const bvLines = computeGroupLines(meal.mealType, meal.ladoo, "primary", targetBv, "balVatika");
  const pLines  = computeGroupLines(meal.mealType, meal.ladoo, "primary", targetP,  "primary");
  const upLines = computeGroupLines(meal.mealType, meal.ladoo, "upper",   targetUp, "upperPrimary");
  const hsLines = computeGroupLines(meal.mealType, meal.ladoo, "upper",   targetHs, "highSchool");
  // Backward-compat: group-level line lists still exposed. Prefer the class
  // that has attendance > 0 in the group; else default to the "senior" class.
  const primaryLines = att.primary > 0 ? pLines : (att.balVatika > 0 ? bvLines : pLines);
  const upperLines   = att.highSchool > 0 ? hsLines : (att.upperPrimary > 0 ? upLines : hsLines);

  // Per-class breakdown — each class now carries ITS OWN lines.
  const classes = [
    { key: "balVatika",    label: "Bal Vatika",    count: att.balVatika,    target: targetBv, lines: bvLines, group: "primary" },
    { key: "primary",      label: "Primary",       count: att.primary,      target: targetP,  lines: pLines,  group: "primary" },
    { key: "upperPrimary", label: "Upper Primary", count: att.upperPrimary, target: targetUp, lines: upLines, group: "upper"   },
    { key: "highSchool",   label: "High School",   count: att.highSchool,   target: targetHs, lines: hsLines, group: "upper"   },
  ].map((c) => {
    // Ladoo cost is part of target on ladoo days; meal cost = target - ladoo.
    const mealPerStudent = c.target - ladooCostPerStudent;
    return {
      ...c,
      perStudent: Number(c.target.toFixed(2)),
      mealCost: Number((c.count * mealPerStudent).toFixed(2)),
      ladooCost: Number((c.count * ladooCostPerStudent).toFixed(2)),
      dayCost: Number((c.count * c.target).toFixed(2)),
    };
  });

  // Aggregated ingredient totals (across all classes).
  const aggregate = new Map();
  const collect = (lines, count) => {
    if (!count) return;
    lines.forEach((l) => {
      const cur = aggregate.get(l.item) || { name: l.item, unit: l.unit, totalQty: 0, totalAmount: 0, isLadoo: !!l.isLadoo, isFree: !!l.isFree, isFlat: l.costMode === "flat" };
      // For flat-cost items (Masala & Salt, Fuel) we now accumulate a real
      // per-student quantity via `qtyPerStudent`. Cost still comes from
      // `costPerStudent` (which is flatPerStudent), so totals stay identical
      // to before this change.
      const qPerStudent = l.costMode === "flat" ? Number(l.qtyPerStudent || 0) : l.qty;
      cur.totalQty += qPerStudent * count;
      cur.totalAmount += l.costPerStudent * count;
      aggregate.set(l.item, cur);
    });
  };
  // iter146 — aggregate PER CLASS so each class contributes ITS OWN qty.
  collect(bvLines, att.balVatika);
  collect(pLines,  att.primary);
  collect(upLines, att.upperPrimary);
  collect(hsLines, att.highSchool);

  const mealCost = classes.reduce((s, c) => s + c.mealCost, 0);
  const ladooCost = classes.reduce((s, c) => s + c.ladooCost, 0);

  return {
    ...meal,
    primaryGroupCount: primaryCount,
    upperGroupCount: upperCount,
    primaryLines,
    upperLines,
    perClass: classes,
    aggregate: Array.from(aggregate.values()),
    perStudentPrimary: targetPri,
    perStudentUpper: targetUpr,
    totals: {
      mealCost: Number(mealCost.toFixed(2)),
      ladooCost: Number(ladooCost.toFixed(2)),
      dayCost: Number((mealCost + ladooCost).toFixed(2)),
    },
  };
}

export function ingredientsForDailyEntry(dateStr, attendance) {
  const breakdown = buildDayBreakdown(dateStr, attendance);
  if (!breakdown || !breakdown.aggregate?.length) return [];
  return breakdown.aggregate.map((row, i) => {
    // Flat-cost items (Masala & Salt, Fuel) now carry a real totalQty in gm.
    // Persist them with both the real qty (so Daily Entry / MDCF / Hand
    // Receipts can show it) AND an `amount` field — `ingredientAmount()`
    // prefers `amount` when present, so the cost math stays exactly as
    // before regardless of qty × rate rounding.
    if (row.isFlat || (row.totalQty === 0 && row.totalAmount > 0)) {
      return {
        id: `auto-${row.name.replace(/\s+/g, "-")}-${i}`,
        name: row.name,
        unit: row.unit || "gm",
        quantity: Number((row.totalQty || 0).toFixed(3)),
        rate: 0,
        amount: Number(row.totalAmount.toFixed(4)),
        isAuto: true,
        isFlat: true,
      };
    }
    return {
      id: `auto-${row.name.replace(/\s+/g, "-")}-${i}`,
      name: row.name,
      unit: row.unit,
      quantity: Number((row.totalQty || 0).toFixed(3)),
      rate: row.totalQty > 0 ? Number((row.totalAmount / row.totalQty).toFixed(4)) : 0,
      isAuto: true,
    };
  });
}

export function daysOfMonth(year, monthIndex0) {
  const days = new Date(year, monthIndex0 + 1, 0).getDate();
  const yy = String(year);
  const mm = String(monthIndex0 + 1).padStart(2, "0");
  return Array.from({ length: days }, (_, i) => `${yy}-${mm}-${String(i + 1).padStart(2, "0")}`);
}

export const MONTH_LIST = [
  { value: 1, label: "January" }, { value: 2, label: "February" }, { value: 3, label: "March" },
  { value: 4, label: "April" }, { value: 5, label: "May" }, { value: 6, label: "June" },
  { value: 7, label: "July" }, { value: 8, label: "August" }, { value: 9, label: "September" },
  { value: 10, label: "October" }, { value: 11, label: "November" }, { value: 12, label: "December" },
];
